import { render, staticRenderFns } from "./ManagerDetails.vue?vue&type=template&id=4b42eb03"
import script from "./ManagerDetails.vue?vue&type=script&lang=js"
export * from "./ManagerDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports